import styled from '@emotion/styled';
import { FC } from 'react';

import { StepConnector, stepConnectorClasses } from '@mui/material';
import { grey } from '@mui/material/colors';

const CustomStepConnectorStyled = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: grey[400],
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: grey[400],
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    borderRadius: 1,
    marginLeft: -16,
    marginRight: -16,
    backgroundColor: grey[100],
  },
}));

const CustomStepConnector: FC = () => {
  return <CustomStepConnectorStyled />;
};

export default CustomStepConnector;
